import tdict_acronyms from './dic/tdict-acronyms.json'
import tdict_city from './dic/tdict-city.json'
import tdict_collection from './dic/tdict-collection.json'
import tdict_common from './dic/tdict-common.json'
import tdict_country from './dic/tdict-country.json'
import tdict_district from './dic/tdict-district.json'
import tdict_geo from './dic/tdict-geo.json'
import tdict_history from './dic/tdict-history.json'
import tdict_ict from './dic/tdict-ict.json'
import tdict_lang_ethnic from './dic/tdict-lang-ethnic.json'
import tdict_proper from './dic/tdict-proper.json'
import tdict_science from './dic/tdict-science.json'
import tdict_spell from './dic/tdict-spell.json'
import tdict_std from './dic/tdict-std.json'
import tdict_std_compound from './dic/tdict-std-compound.json'
import { createPrefixTree } from './prefixtree'

let LEFT = 0
// let RIGHT = 1
let dict: any = []
let tree: any

const init = (words?: string) => {
    dict = []

    addFiles(false)
    if (words !== undefined) {
        addWords(words, false)
    }
    finalizeDict()
}

const addWords = (words: string, finalize?: boolean) => {
    finalize = finalize === undefined || finalize
    dict.push(words)

    if (finalize) {
        finalizeDict()
    }
}

const finalizeDict = () => {
    dict = sortuniq(dict);
    tree = createPrefixTree(dict.map((w: any) => [w, null]))
}

const addFiles = (finalize?: boolean) => {
    finalize = finalize === undefined || finalize;

    tdict_acronyms.forEach(word => addWords(word, false))
    tdict_city.forEach(word => addWords(word, false))
    tdict_collection.forEach(word => addWords(word, false))
    tdict_common.forEach(word => addWords(word, false))
    tdict_country.forEach(word => addWords(word, false))
    tdict_district.forEach(word => addWords(word, false))
    tdict_geo.forEach(word => addWords(word, false))
    tdict_history.forEach(word => addWords(word, false))
    tdict_ict.forEach(word => addWords(word, false))
    tdict_lang_ethnic.forEach(word => addWords(word, false))
    tdict_proper.forEach(word => addWords(word, false))
    tdict_science.forEach(word => addWords(word, false))
    tdict_spell.forEach(word => addWords(word, false))
    tdict_std.forEach(word => addWords(word, false))
    tdict_std_compound.forEach(word => addWords(word, false))

    if (finalize) {
        finalizeDict()
    }
}

const dictSeek = (l: any, r: any, ch: any, strOffset: any, pos: any) => {
    let ans = null

    while (l <= r) {
        var m = Math.floor((l + r) / 2),
            dict_item = dict[m],
            len = dict_item.length;
        if (len <= strOffset) {
            l = m + 1
        } else {
            var ch_ = dict_item[strOffset];
            if (ch_ < ch) {
                l = m + 1
            } else if (ch_ > ch) {
                r = m - 1
            } else {
                ans = m
                if (pos === LEFT) {
                    r = m - 1
                } else {
                    l = m + 1
                }
            }
        }
    }

    return ans
}

const isFinal = (acceptor: any) => {
    return dict[acceptor.l].length === acceptor.strOffset
}

const createAcceptor = () => {
    //   let dict = this

    return {
        nodeId: 0,
        strOffset: 0,
        isFinal: false,
        isError: false,
        tag: "DICT",
        w: 1,
        type: "DICT",
        dict: dict,

        transit(ch: any) {
            return transit(this, ch)
        }
    }
}

const transit = (acceptor: any, ch: any) => {
    let child = tree.lookup(acceptor.nodeId, acceptor.strOffset, ch)
    if (child !== null) {
        let [nodeId, isFinal] = child

        acceptor.nodeId = nodeId
        acceptor.strOffset++
        acceptor.isFinal = isFinal
    } else {
        acceptor.isError = true
    }
    return acceptor
}

const sortuniq = (a: any) => {
    return a.sort().filter(function (item: any, pos: any, arr: any) {
        return !pos || item !== arr[pos - 1];
    })
}

const flatten = (a: any) => {
    //[[1,2],[3]] -> [1,2,3]
    return [].concat.apply([], a);
}

export let WordcutDict = {
    init,
    addWords,
    finalizeDict,
    addFiles,
    dictSeek,
    isFinal,
    createAcceptor,
    transit,
    sortuniq,
    flatten
}